<template>
  <el-card class="box-card">
    <div slot="header" class="flex justify-between">
      <span>商品订单</span>
      <el-button type="primary" size="small" class="float-right" @click="_toShopOrderPage">管理</el-button>
    </div>
    <div class="table-container">
      <el-table :data="shopOrderCartInfo.orders" style="width: 100%" height="450" border>
        <el-table-column prop="prodName" label="商品名称" align="center">
          <template slot-scope="scope">
            <div v-for="(cart, cIndex) in scope.row.carts" :key="cIndex">{{ cart.prodName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="购买数量" align="center">
          <template slot-scope="scope">
            <div v-for="(cart, cIndex) in scope.row.carts" :key="cIndex">x {{ cart.cartNum }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="personName" label="用户名称" align="center"></el-table-column>
        <el-table-column prop="payPrice" label="金额" align="center"></el-table-column>
        <el-table-column prop="stateName" label="订单状态" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openOrderDetailModel(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination-container" @current-change="handleCurrentChange"
        :current-page="pagination.currentPage" :page-size="pagination.pageSize"
        layout="total, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    </div>
  </el-card>
</template>

<script>
import { getStoreOrderList } from '@/api/order/shopOrderApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopOrderCart',
  data() {
    return {
      shopOrderCartInfo: {
        orders: [],
        link: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 7,
        total: 0
      }
    }
  },
  created() {
    this._loadShopOrderCartData(this.pagination.currentPage, this.pagination.pageSize)
  },
  methods: {
    _openOrderDetailModel(order) {
      window.open('/#/pages/goods/storeOrderCartDetail?orderId=' + order.orderId)
    },
    _toShopOrderPage() {
      window.open('/#/pages/order/storeOrderCart?tab=订单信息')
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this._loadShopOrderCartData(val, this.pagination.pageSize)
    },
    _loadShopOrderCartData(page, row) {
      const params = {
        shopId: getShopId(),
        cartType: '3306',
        page,
        row
      }

      getStoreOrderList(params).then(res => {
        this.shopOrderCartInfo.orders = res.data
        this.pagination.total = res.records
      }).catch(() => {
        console.log('请求失败处理')
      })
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.float-right {
  float: right;
}

.table-container {
  height: 450px;
  overflow-y: auto;
  /* 滚动条不显示 */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>